import React, {    } from 'react';
import { Container,Row ,Col   } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; 

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils";



const FOOTERView =  styled.div` 
    font-size: 13px; 
    color:gray;
    background-color: black; 
    position: relative;  `;

    
    const FootW =  styled.div` 
    font-size: 13px;
    margin-left: ${props => props.margin}px;  
    width: ${props => props.width}px; 
    
      `;
 

     
 
const FTopFont =  styled.span`  
color: white;
font-family: 'oswald-medium',oswald,sans-serif; 
font-size: ${props => props.fontSize}px ;  `;
 



const LinkSpan = ({title,link,textAlign}) => {
 
    return <Col style={{ textAlign: textAlign}}>
    <FTopFont className="footer_selected" fontSize={(DeviceUtils.isMobile()===true)?
            30:30}>
                <a href= {link} target="_blank"> 
                {title}
                </a> 
    </FTopFont>
</Col>;
};

// .footer_selected a {
//     padding: 2px 12px;
//     height: 20px;
//     font-size: 18px;
//     color: #ffffff;
//     font-weight: bold;
//   }
//   .footer_selected a:hover {
//     text-decoration: none;
//     color: #cf0101;
//   }

const FooterMainView = () => {


    
    return <FOOTERView >  
            <FootW  
            style={{ marginBottom: "60px",marginTop:'200px'}}
                margin={(DeviceUtils.isMobile()===true)?
                    0:100}
                    width={(DeviceUtils.isMobile()===true)?
                        window.innerWidth:(window.innerWidth-200)}
                >
                    {(DeviceUtils.isMobile()===true)?
                       <div >
                           {/* <div className="pl-3 mb-4">
                                <FTopFont fontSize={(DeviceUtils.isMobile()===true)?
                                30:30}>
                                    info@mysite.com  
                                </FTopFont > 
                           </div> */}
                           <div className="mb-4">
                                <LinkSpan textAlign="left" title="FACEBOOK"
                                link="https://www.facebook.com/SubProStudio" />
                            </div>
        
                            <div className="mb-4">
                                <LinkSpan textAlign="left" title="INSTAGRAM"
                                link="https://www.instagram.com/subprostudio/" />
                            </div>

                            <div className="mb-4">
                                <LinkSpan textAlign="left" title="TWITTER"
                                link="https://twitter.com/StudioSubpro" />
                            </div>

                            <div className="mb-4">
                                <LinkSpan textAlign="left" title="YOUTUBE"
                                    link="https://www.youtube.com/channel/UC4drnDgKEiUERxZpRe04z6Q/featured" /> 
                            </div> 
                       </div>: 

<div>
    <Row>
                        {/* <div  style={{width:(DeviceUtils.isMobile()===true)?`${window.innerWidth}px`:'210px'}}>
                            <FTopFont fontSize={(DeviceUtils.isMobile()===true)?
                            30:30}>
                                info@mysite.com  
                            </FTopFont >
                        </div> */}
                        
                        <div style={{width:`${(DeviceUtils.isMobile()===true)?
                        window.innerWidth:750}px`,position:'absolute', right:'100px'}}>
                            <Row>
                                    <LinkSpan textAlign="right" title="FACEBOOK"
                                link="https://www.facebook.com/SubProStudio" />
        
                                <LinkSpan textAlign="right" title="INSTAGRAM"
                                link="https://www.instagram.com/subprostudio/" />


                                <LinkSpan textAlign="right" title="TWITTER"
                                link="https://twitter.com/StudioSubpro" />

                                <LinkSpan textAlign="right" title="YOUTUBE"
                                link="https://www.youtube.com/channel/UC4drnDgKEiUERxZpRe04z6Q/featured" /> 
                            </Row> 
                        </div>

                        
                    </Row>
</div>
                    }
                </FootW> 

                {(DeviceUtils.isMobile()===true)?
                    <div className="pl-3" style={{
                        fontSize: "13px"}}>
                        © 2021 by SubPro Studio
                    </div>:<FootW 
                    style={{ borderTop: "2px solid white",paddingTop: "40px" }}  
                    margin={(DeviceUtils.isMobile()===true)?
                        0:100}
                        width={(DeviceUtils.isMobile()===true)?
                            window.innerWidth:(window.innerWidth-200)}
                    >
                        © 2021 by SubPro Studio
                    </FootW>}

                
    </FOOTERView>;
};

export default FooterMainView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/footer/FooterMainView.js